import React, { useContext } from 'react'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { Button } from '@/components/buttons/Button'
import { Pill } from '@/components/pills/Pill'

import { AnimateTriggerItem } from './AlertWizard'

import './TriggerItem.css'

export const TriggerItem = ({ item, onItemRemoved, readOnly = false }) => {
  const timeConstrainedHidden = !(item && item.path && item.path.required_before)
  const animate = useContext(AnimateTriggerItem)
  const characterLimit = 80
  const isPopupDisabled = item.path.label.length < characterLimit
  const truncatedDescription = `${item.path.label.slice(0, characterLimit)}…`

  return (
    <div className={`trigger-item-box${animate ? ' added' : ''}`}>
      <div className="trigger-item-name-box">
        <div className="trigger-name">{item.playbook.label}</div>
        <div className="trigger-name">{item.item.label}</div>
        <div className="trigger-name">
          {item.path.value.split('-') &&
            item.path.value.split('-').length > 2 &&
            item.path.value.split('-')[1].trim()}
        </div>
      </div>
      <div data-testid="trigger-item-description">
        <InteractiveTooltip
          interactive
          key={item.path.label}
          placement="top"
          theme="light"
          hide={isPopupDisabled}
          content={
            <>
              <strong>{`${item.playbook.label} - ${item.item.label}`}</strong>
              <p>{item.path.label}</p>
            </>
          }
        >
          {isPopupDisabled ? item.path.label : truncatedDescription}
        </InteractiveTooltip>
      </div>
      <div className="full-width flex-space-between">
        {!timeConstrainedHidden && (
          <div className="mt full-width flex-align-center medium-gap">
            <Pill small caution outlined>
              Time Constrained
            </Pill>
            <div className="muted-text">
              Start of call - {Math.round(item.path.required_before / 60)} min(s)
            </div>
          </div>
        )}

        {!readOnly && (
          <div className="remove-box">
            <Button
              onClick={() => {
                onItemRemoved(item)
              }}
              link
            >
              Remove
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
